import { RouteObject, To } from 'react-router-dom';

interface Props {
  appendSearchParams: (path: string) => To;
}

export const routes = ({}: Props): RouteObject[] => [];
